// SSR safe client-side ID attribute generation
// ID's can only be generated client-side, after mount
// `this._uid` is not synched between server and client
import{COMPONENT_UID_KEY,extend}from'../vue';import{PROP_TYPE_STRING}from'../constants/props';import{makeProp}from'../utils/props';// --- Props ---
export var props={id:makeProp(PROP_TYPE_STRING)};// --- Mixin ---
// @vue/component
export var idMixin=extend({props:props,data:function data(){return{localId_:null};},computed:{safeId:function safeId(){// Computed property that returns a dynamic function for creating the ID
// Reacts to changes in both `.id` and `.localId_` and regenerates a new function
var id=this.id||this.localId_;// We return a function that accepts an optional suffix string
// So this computed prop looks and works like a method
// but benefits from Vue's computed prop caching
var fn=function fn(suffix){if(!id){return null;}suffix=String(suffix||'').replace(/\s+/g,'_');return suffix?id+'_'+suffix:id;};return fn;}},mounted:function mounted(){var _this=this;// `mounted()` only occurs client-side
this.$nextTick(function(){// Update DOM with auto-generated ID after mount
// to prevent SSR hydration errors
_this.localId_="__BVID__".concat(_this[COMPONENT_UID_KEY]);});}});